// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3l8cu","options":"AnswerScale_options__3F755","selected":"AnswerScale_selected__36vqW"};